module.exports = __webpack_public_path__ + "img/is_login.993a18b.svg";